import moment from 'moment';
import { useEffect, useState } from 'react';
import MarketOzonApi from '../../../../API/market/ozon-api';
import MarketWbApi from '../../../../API/market/wb-api';
import MarketYandexApi from '../../../../API/market/yandex-api';
import ProviderInfoApi from '../../../../API/provider/providerInfo-api';
import update_icon from '../../../../assets/media/icons/update.png';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { Icon, Switch } from '../../../../components/Basic/Elements';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../constans';
import { formFullDate } from '../../../../utils';
import styles from './styles.module.scss';

const SHOPS_OZON = [
  { name: 'Озон 1', key: 'ozon1' },
  { name: 'Озон 2', key: 'ozon2' },
  { name: 'Озон 3', key: 'ozon3' },
  { name: 'Озон 4', key: 'ozon4' },
  { name: 'Озон 5', key: 'ozon5' },
  { name: 'Озон 6', key: 'ozon6' },
  { name: 'Озон 7', key: 'ozon7' },
];
const SHOPS_WB = [
  { name: 'Wildberries 1', key: 'wb1' },
  { name: 'Wildberries 2', key: 'wb2' },
  { name: 'Wildberries 3', key: 'wb3' },
  { name: 'Wildberries 4', key: 'wb4' },
  { name: 'Wildberries 5', key: 'wb5' },
  { name: 'Wildberries 6', key: 'wb6' },
  { name: 'Wildberries 7', key: 'wb7' },
];
const SHOPS_YANDEX = [
  { name: 'Яндекс 1', key: 'yandex1' },
  { name: 'Яндекс 3', key: 'yandex3' },
  { name: 'Яндекс 4', key: 'yandex4' },
  { name: 'Яндекс 5', key: 'yandex5' },
  { name: 'Яндекс 6', key: 'yandex6' },
  { name: 'Яндекс 7', key: 'yandex7' },
  { name: 'Яндекс 2 Express', key: 'yandex2' },
  { name: 'Яндекс 8 Express', key: 'yandex8' },
];

const SHOPS_MM = [
  { name: 'СберМаркет 1', key: 'megamarket1' },
  { name: 'СберМаркет 2', key: 'megamarket2' },
];

const MAP_SHOPS = {
  ozon1: 'B-WHITE',
  ozon2: 'B-MAX',
  ozon3: 'OZON-3',
  ozon4: 'OZON-4',
  ozon5: 'OZON-5',
  ozon6: 'OZON-6',
  ozon7: 'OZON-7',
  yandex1: 'B-WHITE',
  yandex2: 'B-MAX',
  yandex3: 'U-RURU',
  yandex4: 'YANDEX-4',
  yandex5: 'YANDEX-5',
  yandex6: 'YANDEX-6',
  yandex7: 'YANDEX-7',
  yandex8: 'YANDEX-8',
  wb1: 'B-WHITE',
  wb2: 'B-MAX',
  wb3: 'U-RURU',
  wb4: 'WB-4',
  wb5: 'WB-5',
  wb6: 'WB-6',
  wb7: 'WB-7',
  megamarket1: 'B-WHITE',
  megamarket2: 'B-MAX',
};
const MAP = {
  Ozon: SHOPS_OZON,
  Wildberries: SHOPS_WB,
  ЯндексМаркет: SHOPS_YANDEX,
  МегаМаркет: SHOPS_MM,
};

const CALLBACK_PRICE_STOCKS = {
  ['Ozon']: MarketOzonApi.updateStocksAndPrices,
  ['Wildberries']: MarketWbApi.updateStocks,
  ['ЯндексМаркет']: MarketYandexApi.updateStocks,
  // ['МегаМаркет']: updateMegamarketStocksAndPricesByProvider,
};
const CALLBACK_PRICE = {
  ['Ozon']: MarketOzonApi.updateStocksAndPrices,
  ['Wildberries']: MarketWbApi.updatePrices,
  ['ЯндексМаркет']: MarketYandexApi.updatePrices,
  // ['МегаМаркет']: updateMegamarketPricesByProvider,
};

let MODE_MAP = {
  Ручной: 'hand',
  Авто: 'auto',
};
const width = ['80px', '150px', '200px', '100px', '100px', '60px', '150px', '180px', '200px', '250px', '50px'];
const StocksUpdateTable = ({ providers = [], market, state, updateStatuses = () => {}, skladName, mode, ...props }) => {
  const [select, setSelect] = useState([]);

  console.log(market);
  useEffect(() => {
    setSelect(MAP[market] || []);
  }, [market]);

  const updateStock = async (shop, provider, isNullStock) => {
    CALLBACK_PRICE_STOCKS[market]({
      data: {
        shop,
        skladName,
        filter: {
          providerId: provider.id === -1 ? undefined : provider.id,
          onlyWarehouse: provider.id === -1,
        },
        rules: {
          nullProvider: isNullStock,
          nullWarehouse: isNullStock,
        },
      },
    });
  };

  const updatePrice = async (shop, provider) => {
    CALLBACK_PRICE[market]({
      data: {
        shop,
        skladName,
        filter: {
          providerId: provider.id === -1 ? undefined : provider.id,
          onlyWarehouse: provider.id === -1,
        },
        rules: { onlyPrices: true },
      },
    });
  };

  const isPrice = state === 'Цена';
  const key = isPrice ? 'price' : 'stock';

  let updateAll = async (provider, isPrice, isNullStock) => {
    for (let i = 0; i < select.length; i++) {
      console.log(select[i]);
      if (isPrice) {
        await updatePrice(select[i].key, provider);
        updateStatuses();
      } else {
        await updateStock(select[i].key, provider, isNullStock);
        updateStatuses();
      }
    }
  };

  return (
    <>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[1]}>Поставщик</HeaderTitle>
          {select.map((market) => (
            <HeaderTitle width={width[2]} centerText={true} key={market.name}>
              {market.name}
            </HeaderTitle>
          ))}
        </TableHeader>
        {providers.map((provider) => {
          return (
            <TableLine key={`${provider.id}`} styles={styles.table_line}>
              <TableCell width={width[1]}>
                <Column>
                  {provider.name}
                  {provider.stock_update.status === 'loaded' && (
                    <TextGrey fontSize={13}>{moment(provider.stock_update.date).fromNow()}</TextGrey>
                  )}
                  {provider.stock_update.status === 'loading' && (
                    <Text className={styles.loaded_text} fontSize={14}>
                      Обновляется
                    </Text>
                  )}
                  {provider.stock_update.status === 'error' && (
                    <Text className={styles.red_text} fontSize={14}>
                      Ошибка
                    </Text>
                  )}
                </Column>
              </TableCell>
              {select.map((market) => {
                let market_data = (provider.markets_update || {})[market.key] || {};
                const data = market_data[skladName]?.[MODE_MAP[mode]]?.[key] || {};

                const status = data.status;
                const date = data.date;

                const all = data.all;
                const done = data.done;

                const last_update = moment(date).fromNow();

                //  console.log(provider, market, ((provider.markets_update || {})[market.key] || {})[key], last_update)

                const calcDiff = (d) => {
                  const start = moment(d);
                  const now = moment();
                  let milisecond = now.diff(start);

                  return milisecond;
                };

                const diff = calcDiff(date);
                const border = 54000000;
                const border_3_days = 259200000;

                return (
                  <TableCell width={width[2]} center={true} key={`${market.key}${provider.id}`}>
                    <Row>
                      {provider.sklads[skladName] && (
                        <>
                          {' '}
                          {status === 'loading' && (
                            <Column style={{ alignItems: 'center' }}>
                              <Text className={styles.loaded_text}>Обновляется</Text>
                              <Text style={{ color: '#ed3f2d', fontWeight: 600 }} fontWeight={600}>{`${Math.ceil(
                                (done / all) * 100,
                              )}%`}</Text>
                            </Column>
                          )}
                          {status === 'stopped' && (
                            <Column style={{ alignItems: 'center' }}>
                              <Text className={styles.stopped_text}>Остановлено</Text>
                              <Text style={{ color: '#106fdc', fontWeight: 600 }} fontWeight={600}>{`${Math.ceil(
                                (done / all) * 100,
                              )}%`}</Text>
                            </Column>
                          )}
                          {status === 'loaded' && (
                            <Column style={{ alignItems: 'center' }}>
                              <Text
                                className={
                                  diff > border_3_days
                                    ? styles.red_text
                                    : diff < border
                                    ? styles.green_text
                                    : styles.blue_text
                                }
                              >
                                {formFullDate(date)}
                              </Text>
                              <TextGrey fontSize={12}>{last_update === 'Invalid date' ? '' : last_update}</TextGrey>
                            </Column>
                          )}
                          {mode === 'Ручной' && (
                            <Button
                              style={{ marginLeft: '4px', width: '50px', height: '50px' }}
                              disabled={provider.sklads[skladName] != true}
                              onClick={() =>
                                isPrice ? updatePrice(market.key, provider) : updateStock(market.key, provider)
                              }
                            >
                              <Icon src={update_icon} width={20} />
                            </Button>
                          )}
                        </>
                      )}
                    </Row>
                  </TableCell>
                );
              })}
              {mode === 'Ручной' && (
                <>
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() => updateAll(provider, isPrice)}
                    disabled={provider.sklads[skladName] != true}
                  >
                    Обновить на всех маркетплейсах
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    onClick={() => updateAll(provider, isPrice, true)}
                    style={{ marginLeft: '10px' }}
                  >
                    Обнулить остатки
                  </Button>
                </>
              )}

              {mode === 'Авто' && (
                <Row style={{ marginLeft: '20px' }}>
                  <Switch
                    switched={provider.is_auto_update_active}
                    onClick={() =>
                      ProviderInfoApi.allowAutoUpdate({
                        data: { providerId: provider.id, status: !provider.is_auto_update_active },
                      })
                    }
                    style={{ marginRight: '8px' }}
                    disabled={[30, 33, 2, 11, 37].indexOf(provider.id) === -1}
                  />{' '}
                  <Text>Автообнуление</Text>
                </Row>
              )}
            </TableLine>
          );
        })}
      </Table>
    </>
  );
};

export default StocksUpdateTable;
